
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-recruitment-software",
      function () {
        return require("private-next-pages/ai-recruitment-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-recruitment-software"])
      });
    }
  